import React from "react";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import UpgradeProgram from "../Components/Dashboard/Manage-My-Program/UpgradeProgram";
import Swal from 'sweetalert2'
const AuthUpgradeprogram = () => {
   const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? <UpgradeProgram /> : <>
  {
     Swal.fire({
      title: "Timeout",
      text: "Your Session has been expired please relogin",
      icon: "info",
      confirmButtonText: "Ok"
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.href="https://accredian.com"
      }
    })
  }
  </>
}
export default AuthUpgradeprogram;
